import React from 'react';
import * as Sentry from "@sentry/react";
// import { ErrorBoundary } from '../../../Services/Sentry';
// const ErrorBoundary = lazy(
//     () => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'../../../Services/Sentry').then(module => ({ default: module.ErrorBoundary }))
// );


export default ({ children }) => {

    const fallback = <div className="rounded-xl bg-red-100 text-red-900 p-4 border border-red-900"
        onClick={() => window.location.reload()}
    >
        <p className="font-bold">Sorry, an error occurred</p>
        <p>Tap here to reload.</p>
    </div>

    return <Sentry.ErrorBoundary showDialog fallback={fallback}>
        {children}
    </Sentry.ErrorBoundary>
}